module.exports = __webpack_public_path__ + "img/13ea31f.svg";